module.exports = __webpack_public_path__ + "static/media/ZFLC.0b2c7cd6.pdf";